import { ProductAttr, ProductAttrValue } from '../models/product';
import { ShoppingCartItem, UserOrderItem } from '../models/shopping';

export interface ProductAttrWithValue {
  attr: ProductAttr;
  value: ProductAttrValue;
}

export const extractShoppingCartItemPricedAttr = (
  item: ShoppingCartItem
): ProductAttrWithValue | undefined => {
  for (const value of item.product.priced_attr.values) {
    if (value.id == item.product_priced_attr_value_id) {
      return {
        attr: item.product.priced_attr,
        value: value,
      };
    }
  }
  return undefined;
};
export const extractShoppingCartItemAttrs = (
  item: ShoppingCartItem | UserOrderItem
): ProductAttrWithValue[] => {
  let attrs = [];
  for (const attr of item.product.attrs) {
    for (const value of attr.values) {
      if (item.product_attr_value_ids.indexOf(value.id) > -1) {
        attrs.push({
          attr: attr,
          value: value,
        });
        break;
      }
    }
  }
  return attrs;
};

export const extractShoppingCartItemImage = (
  item: ShoppingCartItem | UserOrderItem
): string => {
  let image = '';
  const attrs = extractShoppingCartItemAttrs(item);
  for (const attr of attrs) {
    if (attr.value.image) {
      image = attr.value.image;
      break;
    }
  }
  if (!image) {
    image = item.product.images[0];
  }
  return image;
};

export const extractShoppingCartItem = (
  item: ShoppingCartItem | UserOrderItem
): {
  image: string;
  attrs: ProductAttrWithValue[];
  priced_attr?: ProductAttrWithValue;
} => {
  let image = '';
  const attrs = extractShoppingCartItemAttrs(item);
  const priced_attr = extractShoppingCartItemPricedAttr(item);
  for (const attr of attrs) {
    if (attr.value.image) {
      image = attr.value.image;
      break;
    }
  }
  if (!image) {
    image = item.product.images[0];
  }
  return { image, attrs, priced_attr };
};
